<template>
    <div>
        <v-btn fab
               dark
               color="primary"
               class="floating-btn sa-fab"
               :style="language=='ar' ? 'left:20px' : 'right:20px'"
               :title="$t('GenerateSurvey')"
               @click="toggleChat">
            <v-icon size="25">mdi-file-document-edit-outline</v-icon>
        </v-btn>

        <v-card v-if="chatVisible"
                class="sa-panel"
                :class="language=='ar' ? 'sa-left' : 'sa-right'"
                elevation="12"
                :dir="language=='ar' ? 'rtl' : 'ltr'"
                @keydown.esc.native="toggleChat">
            <!-- header -->
            <div class="sa-head">
                <v-avatar size="34" class="sa-head__avatar">
                    <img src="../../assets/images/ai-icon.svg" style="width:20px" alt="AI" />
                </v-avatar>
                <div class="sa-head__titles">
                    <div class="sa-head__title">{{ $t('GenerateSurvey') }}</div>
                    <div class="sa-head__sub">{{ $t('GenerateSurveyHint') }}</div>
                </div>
                <v-spacer />
                <v-btn icon dark small :title="$t('Close')" @click="toggleChat">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>

            <!-- body -->
            <div class="sa-body">
                <v-form ref="form" @submit.prevent="submitSurvey" v-model="valid" lazy-validation>
                    <label class="sa-lbl">{{ $t('SurveyName') }}</label>
                    <v-text-field v-model="surveyName"
                                  :placeholder="$t('SurveyName')"
                                  outlined dense rounded
                                  prepend-inner-icon="mdi-clipboard-text-outline"
                                  required :rules="nameRules" />

                    <label class="sa-lbl">{{ $t('NumberOfQuestions') }}</label>
                    <v-text-field v-model.number="numberOfQuestions"
                                  :placeholder="$t('NumberOfQuestions')"
                                  type="number" min="1" max="50"
                                  outlined dense rounded
                                  prepend-inner-icon="mdi-format-list-numbered"
                                  required :rules="numberRules" />

                    <v-btn color="primary" block large depressed rounded
                           class="sa-generate" type="submit" :loading="loading">
                        <v-icon start class="me-2">mdi-creation</v-icon>
                        {{ $t('GenerateSurvey') }}
                    </v-btn>
                </v-form>
            </div>
        </v-card>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import AiSurveyService from '@/services/AiSurveyService.js'
    export default {
        props: {
            value: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                valid: true,
                loading: false,
                chatVisible: this.value,
                surveyName: '',
                numberOfQuestions: 0,
                nameRules: [
                    v => !!v || this.$t('RequiredField')
                ],
                numberRules: [
                    v => (!!v || v === 0) || this.$t('RequiredField'),
                    v => (v >= 1 && v <= 50) || this.$t('NumberOfQuestionsRange')
                ],
                questions: []
                /*questions: [
{
    'question': 'ما مدى رضاك عن الخدمات التي تقدمها البلديات في مجال النظافة العامة؟',
    'type': 'Rating',
    'options': [],
    'subquestions': [],
    'answer': 3
},
{
    'question': 'هل أنت من سكان المناطق التالية؟ (يمكن اختيار أكثر من منطقة)',
    'type': 'Checkboxes',
    'options': ['الرياض', 'جدة', 'الدمام', 'مكة المكرمة', 'المدينة المنورة'],
    'subquestions': [],
    'answer': ['الرياض', 'جدة']
},
{
    'question': 'ما هي الخدمات التي ترى أنها تحتاج إلى تطوير من قبل البلديات؟',
    'type': 'MultipleChoice',
    'options': ['النظافة', 'الحدائق والمتنزهات', 'رصف الطرق', 'إنارة الشوارع', 'سوق تجاري'],
    'subquestions': [],
    'answer': ['النظافة', 'الحدائق والمتنزهات']
},
{
    'question': 'ما تقييمك لجهود البلديات في مجال التخطيط العمراني؟',
    'type': 'BipolarMatrix',
    'options': ['جيد', 'سيء'],
    'subquestions': [
        {
            'question': 'تنظيم البناء',
            'options': ['ممتاز', 'جيد', 'متوسط', 'سيء', 'سيء جداً'],
            'answer': 'متوسط'
        },
        {
            'question': 'تصميم الشوارع',
            'options': ['ممتاز', 'جيد', 'متوسط', 'سيء', 'سيء جداً'],
            'answer': 'متوسط'
        },
        {
            'question': 'تخطيط المناطق السكنية',
            'options': ['ممتاز', 'جيد', 'متوسط', 'سيء', 'سيء جداً'],
            'answer': 'جيد'
        }
    ],
    'answer': 'متوسط'
},
{
    'question': 'هل أنت راضٍ عن آلية التعامل مع شكاوى المواطنين؟',
    'type': 'YesNo',
    'options': [],
    'subquestions': [],
    'answer': 'No'
},
{
    'question': 'ما مدى رضاك عن قنوات التواصل مع البلدية؟',
    'type': 'NPS',
    'options': [],
    'subquestions': [],
    'answer': 7,
    'nps_promoters': 'ممتاز',
    'nps_passives': 'للأسف سيء'
},
{
    'question': 'ما ملاحظاتك على الخدمات المقدمة؟',
    'type': 'TextArea',
    'options': [],
    'subquestions': [],
    'answer': 'توجد بعض الملاحظات حول نظافة الشوارع وآلية جمع النفايات، حيث لا يتم الاهتمام بالنظافة العامة بالشكل المطلوب.'
},
{
    'question': 'هل سبق لك أن زرت أحد مراكز الخدمة التابعة للبلدية؟',
    'type': 'TrickyQuestion',
    'options': ['نعم', 'لا'],
    'subquestions': [],
    'answer': 'نعم'
},
{
    'question': 'كيف تقيم تجربتك في الحصول على تراخيص البناء؟',
    'type': 'ShortAnswer',
    'options': [],
    'subquestions': [],
    'answer': 'إجراءات طويلة ومرهقة'
},
{
    'question': 'ما اقتراحاتك لتحسين الخدمات البلدية؟',
    'type': 'TextArea',
    'options': [],
    'subquestions': [],
    'answer': 'زيادة عدد الحاويات في الأماكن العامة، وتوفير تطبيق إلكتروني لطلبات المواطنين.'
},
{
    'question': 'هل سبق أن شاركت في مبادرات التطوع البلدي؟',
    'type': 'YesNo',
    'options': [],
    'subquestions': [],
    'answer': 'Yes'
},
{
    'question': 'ما هي أكثر المبادرات التي شاركت بها؟',
    'type': 'MultipleChoice',
    'options': ['إزالة الكتابات من على الجدران', 'تشجير الحدائق', 'تنظيف الشواطئ', 'رسم الجداريات'],
    'subquestions': [],
    'answer': ['إزالة الكتابات من على الجدران', 'تشجير الحدائق']
},
{
    'question': 'كيف تعلمت عن تلك المبادرات؟',
    'type': 'MultipleChoice',
    'options': ['الصحف', 'التلفزيون', 'السوشال ميديا', 'الرسائل النصية', 'الإيميل'],
    'subquestions': [],
    'answer': ['السوشال ميديا']
},
{
    'question': 'هل أنت من مستخدمي تطبيقات البلدية؟',
    'type': 'YesNo',
    'options': [],
    'subquestions': [],
    'answer': 'Yes'
},
{
    'question': 'ما التطبيقات التي تستخدمها؟',
    'type': 'Dropdown',
    'options': ['أمان', 'بلدي', 'آخر'],
    'subquestions': [],
    'answer': 'أمان'
},
{
    'question': 'هل واجهت أي صعوبات في استخدامها؟',
    'type': 'TextArea',
    'options': [],
    'subquestions': [],
    'answer': 'واجهت صعوبة في تحديث البيانات، حيث يطلب مني التطبيق إعادة التسجيل من جديد.'
},
{
    'question': 'هل سبق أن تقدمت بشكوى للبلدية؟',
    'type': 'YesNo',
    'options': [],
    'subquestions': [],
    'answer': 'Yes'
},
{
    'question': 'ما قنوات التواصل التي استخدمتها؟',
    'type': 'Checkboxes',
    'options': ['الهاتف', 'الموقع الإلكتروني', 'تطبيق البلدية', 'الزيارة الشخصية'],
    'subquestions': [],
    'answer': ['الهاتف', 'الموقع الإلكتروني']
},
{
    'question': 'هل تم الرد على شكواك؟',
    'type': 'YesNo',
    'options': [],
    'subquestions': [],
    'answer': 'Yes'
},
{
    'question': 'هل تم حل المشكلة؟',
    'type': 'YesNo',
    'options': [],
    'subquestions': [],
    'answer': 'Yes'
},
{
    'question': 'ما مدى رضاك عن حل المشكلة؟',
    'type': 'Rating',
    'options': [],
    'subquestions': [],
    'answer': 4
},
{
    'question': 'متى قمت بآخر زيارة لموقع البلدية الإلكتروني؟',
    'type': 'Date',
    'options': [],
    'subquestions': [],
    'answer': '2023-07-15'
},
{
    'question': 'هل واجهت أي صعوبات في تصفح الموقع؟',
    'type': 'TextArea',
    'options': [],
    'subquestions': [],
    'answer': 'الموقع يحتاج إلى تحديث وتصميم أكثر مرونة.'
},
{
    'question': 'هل لديك أي اقتراحات أخرى؟',
    'type': 'TextArea',
    'options': [],
    'subquestions': [],
    'answer': 'زيادة الرقابة على المحلات التجارية، وتطبيق الغرامات على المخالفين.'
}
],*/
            }
        },
        computed: {
            ...mapGetters('user', ['language']),

            getLanguage() {
                return this.language == null ? 'ar' : this.language

            },
        },
        watch: {
            value(newValue) {
                this.chatVisible = newValue // Sync when prop changes
            }
        },
        methods: {
            toggleChat() {
                this.chatVisible = !this.chatVisible  // Toggle chat visibility
                this.$emit('openai', this.chatVisible)
            },
            async submitSurvey() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    try {
                        // one call generates the questions AND saves the survey server-side,
                        // so a failure can no longer lose the generated questions
                        // the axios response interceptor already unwraps `.data`, so `result` IS the
                        // ApiResponseDto body: { data: { id, avgTime, questions }, success, message }
                        const result = await AiSurveyService.generateSurvey(this.surveyName, this.numberOfQuestions, this.getLanguage)
                        if (result && result.success && result.data) {
                            this.questions = result.data.questions || []
                            this.chatVisible = false
                            this.$router.push('/add-survey?id=' + result.data.id)
                        } else {
                            this.notifyError(result ? result.message : null)
                        }
                    } catch (error) {
                        const keyword = error && error.response && error.response.data ? error.response.data.message : null
                        this.notifyError(keyword)
                    } finally {
                        this.loading = false
                    }
                }
            },
            notifyError(keyword) {
                const known = ['SurveyDescriptionRequired', 'NumberOfQuestionsRange', 'AiServiceNotConfigured',
                    'AiServiceAuthFailed', 'AiServiceTimeout', 'AiServiceUnreachable', 'AiServiceBadResponse']
                const key = known.includes(keyword) ? keyword : 'ErrorOccurred'
                this.$root.$notification(this.$t(key), 'error')
            },
        },
    }
</script>

<style scoped>
    /* Floating button (generate survey) — upper of the two stacked FABs */
    .sa-fab {
        position: fixed !important;
        bottom: 84px;
        width: 52px !important;
        height: 52px !important;
        box-shadow: 0 4px 14px rgba(27,131,84,.4) !important;
    }

    /* Panel — sa-* namespace so it can't collide with ChatBot's cb-* panel */
    .sa-panel {
        position: fixed;
        bottom: 150px;
        width: 380px;
        max-width: calc(100vw - 32px);
        max-height: calc(100vh - 200px);
        display: flex;
        flex-direction: column;
        overflow: hidden;
        border-radius: 18px !important;
        /* above AddSurvey's sticky buttons (z-index 999999) */
        z-index: 1000000;
    }
    .sa-left { left: 20px; }
    .sa-right { right: 20px; }

    .sa-head {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 12px 14px;
        color: #fff;
        background: linear-gradient(135deg, #1B8354 0%, #28a06a 100%);
        flex: 0 0 auto;
    }
    .sa-head__avatar { background: #fff !important; display: flex; align-items: center; justify-content: center; }
    .sa-head__titles { line-height: 1.2; min-width: 0; }
    .sa-head__title { font-weight: 700; font-size: 15px; }
    .sa-head__sub { font-size: 11px; opacity: .9; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 210px; }

    .sa-body {
        flex: 1 1 auto;
        overflow-y: auto;
        padding: 18px 16px 16px;
        background: #f4f7f6;
    }
    .sa-lbl { display: block; font-size: 13px; font-weight: 600; color: #37474f; margin: 2px 0 6px; }
    .sa-generate { margin-top: 8px; height: 46px !important; font-weight: 700; letter-spacing: .2px; }

    @media (max-width: 480px) {
        .sa-panel { left: 8px !important; right: 8px !important; width: auto; bottom: 150px; }
    }
</style>
